import { Component, ViewChild, ViewEncapsulation, OnInit, AfterViewInit } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { AreaManagerShopModel } from './model/area-manager-shop.model';
import { AreaManagerShopService } from './area-manager-shop.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { ConfirmDialogService } from 'src/app/common/components/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-area-manager-shop',
  standalone: false,
  templateUrl: './area-manager-shop.component.html',
  styleUrl: './area-manager-shop.component.scss'
})
export class AreaManagerShopComponent implements OnInit, DirtyCheck {

  areaManagerShopList: AreaManagerShopModel[] = [];
  rawShops: AreaManagerShopModel[] = [];
  isFormDirty: boolean = false;
  isSaving: boolean = false;

  showSearch: boolean = false;
  isLoading = true;
  IsDownloading = false;
  selectedColor: string = '';

  filter: FilterListItemModel[] = [
    {
      title: "Name",
      column: "name",
    },
  ];

  displayedColumns = ['serial', 'name', 'assign_shop', 'allow_login'];

  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };

  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: AreaManagerShopModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<AreaManagerShopModel>(true, []);
  dataSource = new MatTableDataSource(this.areaManagerShopList);

  areaManagerControl = new FormControl();
  shopSearchControl = new FormControl('');
  filteredManagers!: Observable<any[]>;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;

  selectedManagers: any[] = [];
  selectedAreaManagerId: number | null = null;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private areaManagerShopService: AreaManagerShopService,
    private stateManagerService: StateManagerService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private router: Router,
    private confirmDialogService: ConfirmDialogService
  ) {
    this.areaManagerShopList = [];
    // Custom filter predicate to only search in the shop name column
    this.dataSource.filterPredicate = (data: AreaManagerShopModel, filter: string) => {
      const name = data.name || '';
      return name.toLowerCase().includes(filter);
    };
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });

    this.loadAreaManagerList();
    this.setupShopSearch();
  }

  private setupShopSearch(): void {
    this.shopSearchControl.valueChanges.subscribe(value => {
      const filterValue = (value || '').toLowerCase();
      this.dataSource.filter = filterValue;
    });
  }

  /**
   * Implementation of DirtyCheck interface
   * Checks if there are unsaved changes in shop assignments
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  setDataSource(areaManagerShopList: AreaManagerShopModel[]) {
    this.areaManagerShopList = areaManagerShopList;
    this.dataSource.data = areaManagerShopList;
    this.pagingData.length = areaManagerShopList.length;
  }

  private computeCheckboxStates(shops: AreaManagerShopModel[], managerId: number | null): AreaManagerShopModel[] {
    console.log('=== COMPUTING CHECKBOX STATES ===');
    console.log('Selected Manager ID:', managerId);

    return shops.map((shop, index) => {
      const isAssignedToManager = !!managerId && (shop.area_manager_id === managerId);
      const hasLoginAccess = !!shop.shop_users_id && !!managerId;

      const result = {
        ...shop,
        assign_shop: isAssignedToManager,
        allow_login: hasLoginAccess
      } as AreaManagerShopModel;

      console.log(`Shop ${index + 1} (${shop.name}):`, {
        area_manager_id: shop.area_manager_id,
        shop_users_id: shop.shop_users_id,
        selectedManagerId: managerId,
        assign_shop: result.assign_shop,
        allow_login: result.allow_login
      });

      return result;
    });
  }

  loadAllShops(): void {
    this.isLoading = true;
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "name", order: "asc" }],
      },
    };

    this.areaManagerShopService.getShopList(requestData).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          this.rawShops = response.data.shops || [];

          // Sort shops by name
          this.rawShops.sort((a, b) => {
            const nameA = a.name || '';
            const nameB = b.name || '';
            return nameA.localeCompare(nameB);
          });

          this.updateTableData();
          console.log(`Loaded ${this.rawShops.length} shops initially`);
        } else {
          this.showErrorMessage(response.message || 'Failed to load shops');
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading shops:', error);
        this.showErrorMessage('Error occurred while loading shops');
        this.isLoading = false;
      }
    });
  }

  updateTableData(): void {
    this.areaManagerShopList = this.computeCheckboxStates(this.rawShops, this.selectedAreaManagerId);
    this.setDataSource(this.areaManagerShopList);
  }

  loadAreaManagerList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "name", order: "asc" }],
      },
    };

    this.areaManagerShopService.areaManagerList(requestData).subscribe({
      next: (response: { data: any; status: string }) => {
        if (response.status === "SUCCESS") {
          this.selectedManagers = response.data.managers;
          console.log('Area Managers loaded:', this.selectedManagers);

          // ✅ Setup autocomplete filtering
          this.setupAutocomplete();

          // ✅ Set default value (first manager) and load their shops immediately
          if (this.selectedManagers.length > 0) {
            const defaultManager = this.selectedManagers[0];
            this.areaManagerControl.setValue(defaultManager);
            this.selectedAreaManagerId = defaultManager.user_id;

            // Load shops for the default manager immediately
            this.loadShopsForManager(defaultManager.user_id);

            console.log('Default area manager selected:', defaultManager.name);
          } else {
            // No managers available, show empty state
            this.isLoading = false;
            this.updateTableData();
          }
        } else {
          console.error('Failed to load area managers');
          this.showErrorMessage('Failed to load area managers');
        }
      },
      error: (error: any) => {
        console.error('Error loading area managers:', error);
        this.showErrorMessage('Error occurred while loading area managers');
      }
    });
  }

  // ✅ Setup autocomplete filtering
  private setupAutocomplete(): void {
    this.filteredManagers = this.areaManagerControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        // If an object is selected, return the full list rather than filtering exactly to its name
        if (value && typeof value === 'object') {
          return this.selectedManagers.slice();
        }
        const name = value || '';
        return name ? this._filterManagers(name as string) : this.selectedManagers.slice();
      })
    );
  }

  // ✅ Filter managers based on input
  private _filterManagers(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.selectedManagers.filter(manager =>
      manager.name.toLowerCase().includes(filterValue)
    );
  }

  // ✅ Display function for autocomplete
  displayManagerName(manager: any): string {
    return manager && manager.name ? manager.name : '';
  }

  // ✅ Handle autocomplete selection
  async onAreaManagerSelected(event: MatAutocompleteSelectedEvent): Promise<void> {
    const selectedManager = event.option.value;

    if (this.isDirty()) {
      const message = "You have unsaved shop assignments. Changing the area manager will discard these changes. Do you want to proceed?";
      const dialogData = new ConfirmDialogModel("Discard Unsaved Changes?", message);
      const result = await this.confirmDialogService.openDialog(dialogData);
      if (!result) {
        // Revert the value in the control to the previous manager
        const previousManager = this.selectedManagers.find(m => m.user_id === this.selectedAreaManagerId);
        this.areaManagerControl.setValue(previousManager, { emitEvent: false });
        return;
      }
    }

    this.selectedAreaManagerId = selectedManager.user_id;
    this.isFormDirty = false; // Reset dirty flag as we are loading new data
    console.log('Selected Area Manager:', selectedManager);
    this.loadShopsForManager(selectedManager.user_id);
  }

  loadData(): void {
    if (this.selectedAreaManagerId) {
      this.loadShopsForManager(this.selectedAreaManagerId);
    }
  }

  onRowSelected(areaManagerShopInfo: AreaManagerShopModel): void {
    this.selectedItem = areaManagerShopInfo;
    this.showSummaryPanel = true;
  }

  addClicked(): void {
    this.router.navigate(['user/area-manager-shop-edit', 0]);
  }

  onEdit(areaManagerShop: AreaManagerShopModel): void {
    this.router.navigate(['user/area-manager-shop-edit', areaManagerShop.id]);
  }

  onDelete(areaManagerShop: AreaManagerShopModel): void {
    const dialogData = new ConfirmDialogModel("Confirm Delete", `Are you sure you want to delete ${areaManagerShop.name}?`);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        console.log('Deleting:', areaManagerShop);
      }
    });
  }

  exportClicked(): void {
    this.IsDownloading = true;
    setTimeout(() => {
      this.IsDownloading = false;
    }, 2000);
  }

  onAssignShopChange(areaManagerShop: AreaManagerShopModel, isAssigned: boolean): void {
    if (!this.selectedAreaManagerId) {
      this.showWarningMessage('Please select an area manager first.');
      return;
    }

    console.log(`Changing assign shop for ${areaManagerShop.name} to:`, isAssigned);

    areaManagerShop.assign_shop = isAssigned;

    if (isAssigned) {
      areaManagerShop.area_manager_id = this.selectedAreaManagerId;
    } else {
      areaManagerShop.area_manager_id = null;
      areaManagerShop.allow_login = false;
    }

    this.dataSource.data = [...this.areaManagerShopList];
    this.isFormDirty = true;
  }

  onAllowLoginChange(areaManagerShop: AreaManagerShopModel, allowLogin: boolean): void {
    if (!this.selectedAreaManagerId) {
      this.showWarningMessage('Please select an area manager first.');
      return;
    }

    if (!areaManagerShop.assign_shop) {
      this.showWarningMessage('Shop must be assigned first before allowing login.');
      return;
    }

    console.log(`Changing allow login for ${areaManagerShop.name} to:`, allowLogin);

    areaManagerShop.allow_login = allowLogin;

    if (allowLogin) {
      if (!areaManagerShop.shop_users_id) {
        areaManagerShop.shop_users_id = this.selectedAreaManagerId;
      }
    } else {
      areaManagerShop.shop_users_id = null;
    }

    this.dataSource.data = [...this.areaManagerShopList];
    this.isFormDirty = true;
  }

  // ✅ Updated Save Changes Method - Send detailed shop assignments
  saveChanges(): void {
    if (!this.selectedAreaManagerId) {
      this.showWarningMessage('Please select an area manager before saving.');
      return;
    }

    // ensure managerId is a number (guard above guarantees it's set)
    const managerId = this.selectedAreaManagerId as number;

    // ✅ Build payload with shop assignments (send as array to match service signature)
    const shopAssignments = this.areaManagerShopList.map(shop => ({
      user_id: managerId,
      shop_id: shop.id,
      assign_shop: shop.assign_shop ? 1 : 0,
      allow_login: shop.allow_login ? 1 : 0
    }));

    console.log('Saving changes:', shopAssignments);

    this.isSaving = true;

    // ✅ Call service to save (send array directly)
    this.areaManagerShopService.updateAreaManagerShops(shopAssignments).subscribe({
      next: (response) => {
        this.isSaving = false;
        if (response.status === 'SUCCESS') {
          this.showSuccessMessage('Shop assignments updated successfully!');
          // Reset dirty state after successful save like department edit
          this.isFormDirty = false;
        } else {
          this.showErrorMessage(response.message || 'Failed to update assignments.');
        }
      },
      error: (error: any) => {
        this.isSaving = false;
        console.error('Error saving changes:', error);
        this.showErrorMessage('Failed to save changes.');
      }
    });
  }

  // Helper Methods
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.areaManagerShopList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.areaManagerShopList);
  }

  showErrorMessage(message: string): void {
    let snackBarData: SnackBarData = {
      message: message,
      title: 'Error!',
      type: 'error'
    };
    this.snackBarService.openSnackBar(snackBarData);
  }

  showWarningMessage(message: string): void {
    let snackBarData: SnackBarData = {
      message: message,
      title: 'Warning!',
      type: 'warn'
    };
    this.snackBarService.openSnackBar(snackBarData);
  }

  showSuccessMessage(message: string): void {
    let snackBarData: SnackBarData = {
      message: message,
      title: 'Success!',
      type: 'success'
    };
    this.snackBarService.openSnackBar(snackBarData);
  }

  sortData(event: any): void {
    // Handle sorting if needed
    console.log('Sort event:', event);
  }

  // ✅ Add this method to your AreaManagerShopComponent class
  loadShopsForManager(managerId: number): void {
    this.isLoading = true;
    console.log('Loading shops for area manager ID:', managerId);

    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "name", order: "asc" }],
      },
      area_manager_id: managerId
    };

    this.areaManagerShopService.getShopList(requestData).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          this.rawShops = response.data.shops || [];

          // Sort shops by name
          this.rawShops.sort((a, b) => {
            const nameA = a.name || '';
            const nameB = b.name || '';
            return nameA.localeCompare(nameB);
          });

          this.updateTableData();
          console.log(`Loaded ${this.rawShops.length} shops for area manager ${managerId}`);
        } else {
          this.showErrorMessage(response.message || 'Failed to load shops');
        }
        this.isLoading = false;
      },
      error: (error: any) => {
        console.error('Error loading shops:', error);
        this.showErrorMessage('Error occurred while loading shops');
        this.isLoading = false;
      }
    });
  }

  // ✅ Also add the updateTableData method if it's missing
  // updateTableData(): void {
  //   this.areaManagerShopList = this.computeCheckboxStates(this.rawShops, this.selectedAreaManagerId);
  //   this.setDataSource(this.areaManagerShopList);
  // }

  // ✅ And keep the existing onAreaManagerChange method for backward compatibility
  onAreaManagerChange(managerId: number | null): void {
    this.selectedAreaManagerId = managerId;
    console.log('Selected Area Manager ID:', managerId);

    if (managerId) {
      this.loadShopsForManager(managerId);
    } else {
      this.rawShops = [];
      this.updateTableData();
    }
  }

  // ✅ Add clear method
  clearAreaManager(): void {
    this.areaManagerControl.setValue(null);
    this.selectedAreaManagerId = null;
    this.rawShops = [];
    this.updateTableData();
    console.log('Area Manager selection cleared');
  }

  // ✅ Add resetToDefault method with dirty check
  async resetToDefault(): Promise<void> {
    if (this.isFormDirty) {
      const dialogData = new ConfirmDialogModel(
        "Discard Changes?",
        "Are you sure you want to discard your unsaved changes and reset the list?"
      );
      const result = await this.confirmDialogService.openDialog(dialogData);
      if (!result) return;
    }

    if (this.selectedAreaManagerId) {
      this.loadShopsForManager(this.selectedAreaManagerId);
    }
    this.isFormDirty = false;
  }
}
